import type { Branded } from './branded'
import type { IssueId } from './issue'
import type { ProjectId, UserId } from './project'

type PlanId = Branded<string, 'PlanId'>

const planId = (value: string): PlanId => value as PlanId

const PLAN_STATUS = {
	DRAFT: 'draft',
	ACTIVE: 'active',
	DONE: 'done',
	ABANDONED: 'abandoned',
} as const

const PLAN_STATUSES = [PLAN_STATUS.DRAFT, PLAN_STATUS.ACTIVE, PLAN_STATUS.DONE, PLAN_STATUS.ABANDONED] as const

type PlanStatus = (typeof PLAN_STATUSES)[number]

const DEFAULT_PLAN_STATUSES: readonly PlanStatus[] = PLAN_STATUSES.filter(
	status => status !== PLAN_STATUS.DONE && status !== PLAN_STATUS.ABANDONED,
)

type Plan = {
	readonly id: PlanId
	readonly projectId: ProjectId
	readonly ticketId: IssueId | undefined
	readonly title: string
	readonly goal: string
	readonly status: PlanStatus
	readonly tags: readonly string[]
	readonly createdBy: UserId | undefined
	readonly createdAt: Date
	readonly updatedAt: Date
}

const isTerminal = (status: PlanStatus): boolean => status === PLAN_STATUS.DONE || status === PLAN_STATUS.ABANDONED

export { DEFAULT_PLAN_STATUSES, isTerminal, PLAN_STATUS, PLAN_STATUSES, planId }
export type { Plan, PlanId, PlanStatus }
